import { render, staticRenderFns } from "./PermissionRecordChilds.vue?vue&type=template&id=c1e86562&scoped=true"
import script from "./PermissionRecordChilds.vue?vue&type=script&lang=js"
export * from "./PermissionRecordChilds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e86562",
  null
  
)

export default component.exports